import React from 'react';
import { Check } from 'lucide-react';
interface Step {
  id: string;
  label: string;
  path: string;
}
interface WizardStepperProps {
  steps: Step[];
  currentStepIndex: number;
}
export function WizardStepper({
  steps,
  currentStepIndex
}: WizardStepperProps) {
  return <nav aria-label="Progress" data-id="element-204">
      <ol role="list" className="flex items-center" data-id="element-205">
        {steps.map((step, stepIdx) => {
        const isCompleted = stepIdx < currentStepIndex;
        const isCurrent = stepIdx === currentStepIndex;
        return <li key={step.id} className={`relative ${stepIdx !== steps.length - 1 ? 'pr-8 sm:pr-20' : ''}`} data-id="element-206">
              {stepIdx !== steps.length - 1 && <div className="absolute top-4 left-0 -ml-px mt-0.5 w-full h-0.5 bg-navy-700" aria-hidden="true" data-id="element-207">
                  <div className={`h-full bg-teal-500 transition-all duration-500 ease-in-out ${isCompleted ? 'w-full' : 'w-0'}`} data-id="element-208" />
                </div>}
              <div className="group relative flex flex-col items-center" data-id="element-209">
                <span className="flex items-center h-9" aria-hidden="true" data-id="element-210">
                  {isCompleted ? <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-teal-500 rounded-full group-hover:bg-teal-600 transition-colors" data-id="element-211">
                      <Check className="w-5 h-5 text-white" data-id="element-212" />
                    </span> : isCurrent ? <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-navy-900 border-2 border-teal-500 rounded-full" data-id="element-213">
                      <span className="h-2.5 w-2.5 bg-teal-500 rounded-full" data-id="element-214" />
                    </span> : <span className="relative z-10 w-8 h-8 flex items-center justify-center bg-navy-800 border-2 border-slate-700 rounded-full group-hover:border-slate-500 transition-colors" data-id="element-215">
                      <span className="h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-slate-600" data-id="element-216" />
                    </span>}
                </span>
                <span className={`mt-2 text-xs font-medium uppercase tracking-wider ${isCurrent ? 'text-teal-500' : isCompleted ? 'text-slate-300' : 'text-slate-500'}`} data-id="element-217">
                  {step.label}
                </span>
              </div>
            </li>;
      })}
      </ol>
    </nav>;
}